import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "crm-worklist-page" };
const _hoisted_2 = { class: "sla-countdown" };
const _hoisted_3 = { class: "entity-tag" };
const _hoisted_4 = {
    key: 0,
    class: "complaint-badge"
};
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import AdminTable from '@/admin/components/AdminTable.vue';
import { useAdmin } from '@/composables/useAdmin';
import { slaCountdown } from '@/composables/useAdminCrm';
const W = 'minmax(0, 1fr)';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CrmWorkListPage',
    setup(__props) {
        const router = useRouter();
        const admin = useAdmin();
        const loading = ref(true);
        const items = ref([]);
        const employers = ref([]);
        const columns = [
            { field: 'followUpDue', label: 'Due', sortable: true, filterable: true, type: 'date', width: W },
            { field: 'entityName', label: 'Who', sortable: true, filterable: true, filterType: 'text', width: 'minmax(0, 1.5fr)' },
            { field: 'title', label: 'Title', sortable: true, filterable: true, filterType: 'text', width: 'minmax(0, 2fr)' },
            { field: 'reason', label: 'Reason', sortable: true, filterable: true, filterType: 'select', width: W },
            { field: 'method', label: 'Method', sortable: true, filterable: true, filterType: 'select', width: W },
            { field: 'contactDateTime', label: 'Contact Date', sortable: true, filterable: true, type: 'date', width: W },
        ];
        // The server returns the operator's contacts; the to-do list is those with an open follow-up
        const rows = computed(() => items.value
            .filter(c => c.followUpDue && !c.followedUp)
            .map(c => ({
            id: c.id,
            followUpDue: c.followUpDue,
            sla: slaCountdown(c.followUpDue),
            entityId: c.entityId,
            entityType: (c.entityIsCustomer ? 'customer' : 'employer'),
            entityName: entityNameFor(c),
            title: c.thread?.title || '',
            reason: c.contactReason?.name || '—',
            complaint: !!c.contactReason?.complaint,
            method: c.contactMethod?.name || '—',
            contactDateTime: c.contactDateTime,
        }))
            .sort((a, b) => (a.followUpDue || '').localeCompare(b.followUpDue || '')));
        // Worklist items only carry an entity ID — resolve names from the loaded customer/employer lists
        function entityNameFor(contact) {
            if (contact.entityIsCustomer) {
                const customer = (admin.adminState.customers || []).find((c) => c.id === contact.entityId);
                return customer?.person ? `${customer.person.firstName} ${customer.person.lastName}` : contact.entityId;
            }
            const employer = employers.value.find((e) => e.id === contact.entityId);
            return employer?.name || contact.entityId;
        }
        function formatDate(value) {
            if (!value)
                return '—';
            return new Date(value).toLocaleDateString('en-GB');
        }
        function formatDateTime(value) {
            if (!value)
                return '—';
            return new Date(value).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        function openContact(row) {
            router.push(`/admin/crm/${row.entityType}/${row.entityId}?contactId=${row.id}`);
        }
        onMounted(() => {
            if (!admin.adminState.customers?.length)
                admin.getCustomers();
            admin.getEmployers((result) => { employers.value = result || []; });
            admin.getCrmWorkList((result) => {
                items.value = result || [];
                loading.value = false;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(AdminTable, {
                    title: "My Follow-ups",
                    icon: "📇",
                    columns: columns,
                    data: rows.value,
                    loading: loading.value,
                    selectable: true,
                    searchable: true,
                    "search-placeholder": "Filter by name, title, reason…",
                    "empty-message": "No follow-ups due — open a customer or employer and use their CRM button to log contacts",
                    onRowSelect: openContact
                }, {
                    "cell-followUpDue": _withCtx(({ row }) => [
                        _createElementVNode("span", {
                            class: _normalizeClass({ overdue: row.sla.breached })
                        }, [
                            _createTextVNode(_toDisplayString(formatDate(row.followUpDue)) + " ", 1),
                            _createElementVNode("span", _hoisted_2, _toDisplayString(row.sla.label), 1)
                        ], 2)
                    ]),
                    "cell-entityName": _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(row.entityName), 1),
                        _createElementVNode("span", _hoisted_3, _toDisplayString(row.entityType === 'employer' ? 'Employer' : 'Member'), 1)
                    ]),
                    "cell-title": _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(row.title || '(untitled)'), 1)
                    ]),
                    "cell-reason": _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(row.reason), 1),
                        (row.complaint)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Complaint"))
                            : _createCommentVNode("", true)
                    ]),
                    "cell-contactDateTime": _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(formatDateTime(row.contactDateTime)), 1)
                    ]),
                    _: 1
                }, 8, ["data", "loading"])
            ]));
        };
    }
});
